import React from "react";
import PropTypes from "prop-types";
import { List } from "./List";
import { Option } from "./Option";
import { Wrapper } from "./Wrapper";
import { Technique } from "../../Technique";
import { Utilities } from "@learningblocks/exp-constants";
const { COMPONENT_TYPE, DRAG_DROP_DATA, DRAG_DROP__ID, DRAG_DROP__TYPE } =
  Utilities;

export function Techniques(props) {
  const onDragStart = (optionId) => (event) => {
    const dropData = {};
    dropData[DRAG_DROP__ID] = optionId;
    dropData[DRAG_DROP__TYPE] = COMPONENT_TYPE.TECHNIQUE_CARD;
    event.dataTransfer.setData(DRAG_DROP_DATA, JSON.stringify(dropData));
  };

  const onSelect = (optionId) => () => {
    props.onSelect({ optionId, componentType: COMPONENT_TYPE.TECHNIQUE_CARD });
  };

  const renderOption = (option) => {
    if (option.visible) {
      return (
        <Option onDragStart={onDragStart(option.id)} key={option.id}>
          <Technique
            tabIndex={0}
            title={option.title}
            image={option.image}
            description={option.description}
            onSelect={onSelect(option.id)}
            glossaryId={option.glossaryId}
            isEmpty={true}
          />
        </Option>
      );
    } else return null;
  };

  const className = `techniquesOption ${props.className}`;

  return (
    <Wrapper className={className}>
      <List className="techniquesOption_list">
        {props.list.map(renderOption)}
      </List>
    </Wrapper>
  );
}

Techniques.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * List of options
   */
  list: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of the rectangle card
       */
      id: PropTypes.number,
      /**
       * Title of the rectangle card
       */
      title: PropTypes.string,
      /**
       * image to display in the rectangle card
       */
      image: PropTypes.string,
      /**
       * short description to display in the rectangle card
       */
      description: PropTypes.string,
      /**
       * Triggered on click of MoveIcon
       */
      onSelect: PropTypes.func,
    })
  ),
};

Techniques.defaultProps = {
  className: "",
};
